<mat-menu id="columns-menu" >
  <div class="columnSettingsContainer"
    (click)="$event.stopPropagation()">
    @for (column of columns; track column) {
      <div class="flex flex-col">

        @for (group of column; track group) {
          <div class="group">
            <div class="flex flex-row items-center columnSettingsGroupCheckbox">
              <mat-checkbox (change)="columnGroupCheckboxOnChange(group)"
                            [checked]="allChecked(group)"
                            [indeterminate]="!allChecked(group) && someChecked(group)">
                <span>{{ group }}</span>
              </mat-checkbox>
            </div>
            @for (fieldId of getColumnGroupIds(group); track fieldId; let i = $index) {
              <div [ngClass]="{'mt-1': i !== 0}"
                   class="columnSettingsCheckbox flex flex-row">
                <mat-checkbox name="{{fieldId}}"
                              (ngModelChange)="columnCheckboxOnChange(fieldId, $event)"
                              [ngModel]="(viewModel$ | ngrxPush)[fieldId]">
                  <div class="items-center flex justify-between">
                    <span>{{ getFieldNameByFieldID(fieldId) }}</span>
                    @if (visibilityMirroredInCC(fieldId)) {
                      <mat-icon svgIcon="cc_search" class="text-neutral-60 h-4 w-4 ml-2 mb-2 searchIcon"/>
                    }
                  </div>
                </mat-checkbox>
              </div>
            }
          </div>
        }

      </div>
    }

  </div>
</mat-menu>
